import axios from 'axios';
import { getHeaders } from "./index";
import{ ROOT_API_URL } from '../app.config';

const PROFILE_ID = 'profile_id';
const PROFILE_URL = `${ROOT_API_URL}/profile/api/profiles/`;
const PROFILE_SEARCH_URL = `${ROOT_API_URL}/profile/search/`;
const PROFILE_UPDATE_URL = `${ROOT_API_URL}/profile/custom`;
const PROFILE_IMAGE_URL = `${ROOT_API_URL}/profile/api/images/`;
const FEEDBACK_URL = `${ROOT_API_URL}/profile/api/feedback/`;
const CONFIRM_PHONE_NUMBER_URL = `${ROOT_API_URL}/confirmPhoneNumber/`;
const USERNAME_EXISTS_URL = `${ROOT_API_URL}/profile/username-exists/`;
const USER_EMAIL_EXISTS_URL = `${ROOT_API_URL}/profile/user-email-exists/`;

export const clearProfileId = () => {
  localStorage.removeItem(PROFILE_ID);
};

export const getProfileId = () => {
  return localStorage.getItem(PROFILE_ID);
};

export const setProfileId = (profile_id) => {
  localStorage.setItem(PROFILE_ID, profile_id);
};

export const getProfile = () => {
  return axios.get(`${PROFILE_URL}${getProfileId()}/`, {
    headers: getHeaders()
  });
};

export const searchProfiles = (searchValue, slug) => {
  return axios.post(PROFILE_SEARCH_URL, { q: searchValue, slug: slug}, {
    headers: getHeaders()
  });
};

export const confirmPhoneNumber = payload => {
  return axios.post(`${CONFIRM_PHONE_NUMBER_URL}`, payload, {
    headers: getHeaders()
  });
};

export const sendFeedback = payload => {
  return axios.post(`${FEEDBACK_URL}`, payload, {
    headers: getHeaders()
  });
};

export const updateProfile = (slug, payload) => {
  return axios.put(`${PROFILE_UPDATE_URL}/${slug}/`, payload, {
    headers: getHeaders()
  });
};

export const uploadProfileImage = payload => {
  return axios.post(PROFILE_IMAGE_URL, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
      ...getHeaders(),
    }
  });
};

export const checkUsernameExists = username => {
  return axios.get(`${USERNAME_EXISTS_URL}`, {
    headers: getHeaders(),
    params: { username },
  });
};

export const checkUserEmailExists = email => {
  return axios.get(`${USER_EMAIL_EXISTS_URL}`, {
    headers: getHeaders(),
    params: { email },
  });
};


// WEBPACK FOOTER //
// ./src/services/profile.service.js